import { tv } from '~/utils/tv'

export const modalDescriptionStyles = tv({
  base: 'line-clamp-5 pt-none pr-none pb-none pl-none text-left font-rdmodern font-regular text-text-neutral text-threeandhalfpulse leading-small tracking-tiny',
})
